import React,{useEffect, useState} from "react";
import styles from './Home2.module.css';
import { Link } from "react-router-dom";
import ReactGA from 'react-ga';

import LogoPrincipal from './assets/LogoPrincipalHome.png'
import Paso1 from './assets/Paso1.png';
import Paso2 from './assets/Paso2.png';
import paso3 from './assets/Paso3.png';


import LogoConcierto from './assets/CoollogoConciertos.png'
import Gaseosas from './assets/Gaseosas.png'
import LogoIsm from './assets/LogoISM.png'
import GaseosasMobile from './assets/GaseosasMobile.png'
import LogoISMMobile from './assets/LogoISMMobile.png'
import pasomobile from './assets/paso2_mobile.png'
///imagenes responsive////




const Home2 = () => {


  useEffect(() => {
    ReactGA.pageview('/');
    document.title = "Destapa y gana conciertos gratis por un año / Cool Fresh, una marca de ISM";

    // Actualizar la descripción de la página
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Destapa y gana conciertos gratis por un año con Cool Fresh, una marca de ISM");
    }
  },[]);

    return(
        <div className={styles.Home}>
          
            <img  alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' src={LogoPrincipal} style={{zIndex:'200'}} className={styles.LogoPrincipal}></img>
            
            <div className={styles.lefDiv}>
            <div className={styles.divLogos}>
               <img alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' src={Paso1} className={styles.Paso1}></img>
               <img  alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' src={Paso2} className={styles.Paso2}></img> 
               <img  alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' src={pasomobile} className={styles.pasomobile}></img> 
             </div>     
             <img src={paso3} className={styles.Paso3}></img> 
            
             <Link to={'/ingresoDNI'}>
               <button className={styles.button} style={{zIndex:'100'}}>PARTICIPA AQUÍ</button>
             </Link>   
             <p className={styles.p} style={{zIndex:'400px'}}>
              Si vienes por primera vez, <Link style={{color:' #FFFFFF', zIndex:'400',color:'#ffce36'}} to={'/registro'}>regístrate aquí.</Link> </p>
            
              <p className={styles.p2} style={{zIndex:'400px'}} >
              Promoción válida para las ciudades de Lima, Arequipa, Cusco, Ica, Puno, Juliaca, Chincha, Chimbote, Tacna y Huacho, Stock total de premios son 240 entradas y 60,000 unidades de Cool Fresh 350ml gratis. Promoción válida del 13 de noviembre de 2023 al 30 de enero de 2024 y/o hasta agotar stock, para consultas sobre el desarrollo de la Promoción y visualizar los términos y condiciones ingresar a www.coolfresh.pe ó al Instagram @gaseosacool.
              </p>
             </div>
             <img style={{zIndex:'10px'}}  alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' src={LogoConcierto} className={styles.LogoConcierto}></img>
       
             <img style={{zIndex:'10px'}}  alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' src={Gaseosas} className={styles.Gaseosas}></img>
             <img  style={{zIndex:'10px'}}  alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' src={GaseosasMobile} className={styles.GaseosasMobile}></img>

             <img  alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' src={LogoIsm} className={styles.LogoIsm}></img>
             <img  alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' src={LogoISMMobile} className={styles.LogoISMMobile}></img>
        </div>
    )
}

 
export default Home2